import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import { authHeaders } from '@/services/session.js';

import '@/registerServiceWorker'
import '@/sass/main.scss';
import '@/filters/filters.js';

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
Vue.use(PulseLoader)

import VueOffline from 'vue-offline'
Vue.use(VueOffline)

import Notifications from 'vue-notification'
Vue.use(Notifications)

axios.interceptors.request.use(function (config) {
  const headers = authHeaders();
  if (headers.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = headers.Authorization;
  }
  return config;
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  const status = error && error.response && error.response.status;
  const requestUrl = (error && error.config && error.config.url) || '';
  const isLoginRequest = /\/tokens\/?$/.test(requestUrl);
  if (status === 401 && !isLoginRequest) {
    store.dispatch('auth/logout');
    if (router.currentRoute && router.currentRoute.name !== 'login') {
      router.push('/login');
    }
    Vue.notify({
      title: "Ups!",
      text:  "Sesión caducada",
      type:  "warn"
    });
  }

  return Promise.reject(error)
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
